

export default {
  name: "Profile",
  update: "Update Profile",
  photo: "Profile photo",
  account_information: "Account Information",
  personal_information: "Personal Information",
}
